import {
  BookImage,
  Fingerprint,
  Group,
  LogOut,
  PresentationIcon,
  Search,
  Settings,
  Sliders,
  User,
  UsersRound,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { TenantLogo } from '../TenantLogo';

import { FooterLink } from './components/FooterLink';
import { NavigationLink } from './components/NavigationLink';
import { NewConversationButton } from './components/NewConversationButton';

import { ROUTE_PATHS } from '@/config/constants';
import { useAuth } from '@/contexts/AuthContext';

export function NavigationBar() {
  const { user } = useAuth();

  const { pathname } = useLocation();

  const { t } = useTranslation('translation', {
    keyPrefix: 'components.NavigationBar',
  });

  return (
    <aside className="hidden w-[282px] lg:block">
      <div className="sticky left-0 top-0 flex h-dvh w-[282px] flex-col overflow-scroll px-6 py-10 scrollbar-hide">
        <header className="mb-9 flex items-center justify-between">
          <Link to={ROUTE_PATHS.HOME}>
            <TenantLogo />
          </Link>

          {pathname === ROUTE_PATHS.COPILOT && <NewConversationButton />}
        </header>

        <nav className="mb-[10px] flex-1">
          <ul className="flex flex-col gap-4">
            <NavigationLink to={ROUTE_PATHS.VISION_ENRICHMENT}>
              <BookImage /> {t('visionEnrichment')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.TAXONOMY}>
              <Fingerprint /> {t('taxonomy')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.PERSONALIZATION}>
              <Sliders /> {t('personalization')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.AUDIENCES} isInBeta>
              <User /> {t('behaviors')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.SEO_CONTENT}>
              <Search /> {t('seoContent')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.MERCHANDISING_COLLECTIONS}>
              <Group /> {t('merchandisingCollection')}
            </NavigationLink>

            <NavigationLink to={ROUTE_PATHS.PROFILES}>
              <UsersRound /> {t('profiles')}
            </NavigationLink>

            {(user?.customer?.fetchedProducts ||
              user?.customer?.freemiumFetchedProducts) && (
              <NavigationLink to={ROUTE_PATHS.DEMO}>
                <PresentationIcon /> {t('demo')}
              </NavigationLink>
            )}
          </ul>
        </nav>

        <footer>
          <nav>
            <ul>
              <FooterLink to={ROUTE_PATHS.SETTINGS}>
                {t('settings')} <Settings />
              </FooterLink>

              <FooterLink to={ROUTE_PATHS.LOGOUT}>
                {t('logout')} <LogOut />
              </FooterLink>
            </ul>
          </nav>
        </footer>
      </div>
    </aside>
  );
}
